var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"padding-right":"2px"}},[_vm._v(" If you do not have a CBOM, visualize our ")]),_c('cv-button',{staticStyle:{"padding":"3px"},attrs:{"icon":_vm.ArrowRight24,"kind":"ghost"},on:{"click":function($event){return _vm.showResultFromUpload(_vm.demoCbom, '')}}},[_vm._v(" sample CBOM file ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }